import { addDaysYmd } from "./hrUi";

// First and last day of the month containing `ymd` ("2026-10-15" -> 2026-10-01 .. 2026-10-31).
export function monthBounds(ymd) {
  const [y, m] = ymd.split("-").map(Number);
  const first = `${y}-${String(m).padStart(2, "0")}-01`;
  const next = m === 12 ? `${y + 1}-01-01` : `${y}-${String(m + 1).padStart(2, "0")}-01`;
  return { from: first, to: addDaysYmd(next, -1) };
}

export function shiftMonth(ymd, delta) {
  const [y, m] = ymd.split("-").map(Number);
  const total = y * 12 + (m - 1) + delta;
  const ny = Math.floor(total / 12);
  const nm = (total % 12) + 1;
  return `${ny}-${String(nm).padStart(2, "0")}-01`;
}

// rows: the API's calendar rows ({ employee_id, full_name, leave_date, fraction, status, color, leave_type_name }).
// Returns { days: ["2026-10-01", ...], people: [{ employee_id, full_name, cells: { date: { fraction, pending, color, type } } }] }
// with people in name order. One person on two half-day requests the same day is one full cell.
export function buildCalendarGrid(rows, from, to) {
  const days = [];
  for (let d = from; d <= to; d = addDaysYmd(d, 1)) days.push(d);
  const byPerson = new Map();
  for (const r of rows || []) {
    const date = String(r.leave_date).slice(0, 10);
    if (date < from || date > to) continue;
    if (!byPerson.has(r.employee_id)) byPerson.set(r.employee_id, { employee_id: r.employee_id, full_name: r.full_name, cells: {} });
    const person = byPerson.get(r.employee_id);
    const cell = person.cells[date];
    const fraction = Number(r.fraction) || 1;
    const pending = r.status === "PENDING";
    person.cells[date] = cell
      ? { fraction: Math.min(1, cell.fraction + fraction), pending: cell.pending && pending, color: cell.color, type: cell.type }
      : { fraction, pending, color: r.color || "#C9194A", type: r.leave_type_name };
  }
  const people = [...byPerson.values()].sort((a, b) => String(a.full_name).localeCompare(String(b.full_name)));
  return { days, people };
}
